import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=75b1c8b2&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=75b1c8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b1c8b2",
  null
  
)

export default component.exports